module.exports = __webpack_public_path__ + "static/media/vendetta.91ac6933.svg";